function Recruit() {
    return (
        <div className="bg-gradient-to-r from-yellow-300 text-xl lg:text-3xl to-pink-300 container h-screen flex justify-center">
            <div className="mt-16 font-bold text-pink-700">Hiện tại không có thông tin tuyển dụng</div>
        </div>
    );
}

export default Recruit;
